module.exports = Vue2StoragePlugin;